<div class="hijri-datepicker" [class.hijri-datepicker--open]="isOpen" [class.hijri-datepicker--disabled]="disabled">
  <div class="hijri-datepicker__input-group" (click)="toggle()">
    <input
      type="text"
      class="hijri-datepicker__input"
      [value]="hijriDisplay"
      [placeholder]="placeholder"
      [disabled]="disabled"
      readonly
    />
    <button
      *ngIf="hijriDisplay && !disabled"
      type="button"
      class="hijri-datepicker__clear"
      (click)="clear($event)"
      aria-label="clear"
    >
      <i class="pi pi-times"></i>
    </button>
    <button
      type="button"
      class="hijri-datepicker__trigger"
      [disabled]="disabled"
      aria-label="open-calendar"
    >
      <i class="pi pi-calendar"></i>
    </button>
  </div>

  <div class="hijri-datepicker__popup" *ngIf="isOpen && !disabled" (click)="$event.stopPropagation()">
    <div class="hijri-datepicker__header">
      <button type="button" class="hijri-datepicker__nav" (click)="prevMonth()" aria-label="prev">
        <i class="pi pi-chevron-right"></i>
      </button>
      <select class="hijri-datepicker__select" [ngModel]="viewMonth" (ngModelChange)="onMonthChange($event)">
        <option *ngFor="let m of hijriMonths" [ngValue]="m.value">
          {{ lang === 'en' ? m.labelEn : m.labelAr }}
        </option>
      </select>
      <select class="hijri-datepicker__select" [ngModel]="viewYear" (ngModelChange)="onYearChange($event)">
        <option *ngFor="let y of hijriYears" [ngValue]="y">{{ y }}</option>
      </select>
      <button type="button" class="hijri-datepicker__nav" (click)="nextMonth()" aria-label="next">
        <i class="pi pi-chevron-left"></i>
      </button>
    </div>

    <div class="hijri-datepicker__weekdays">
      <span *ngFor="let w of weekdays">{{ w }}</span>
    </div>

    <div class="hijri-datepicker__grid">
      <div class="hijri-datepicker__row" *ngFor="let row of grid">
        <button
          type="button"
          *ngFor="let cell of row"
          class="hijri-datepicker__cell"
          [class.is-selected]="cell.isSelected"
          [class.is-today]="cell.isToday"
          [class.is-empty]="cell.day === null"
          [class.is-disabled]="cell.isDisabled"
          [disabled]="cell.day === null || cell.isDisabled"
          (click)="selectDay(cell, $event)"
        >
          {{ cell.day }}
        </button>
      </div>
    </div>
  </div>
</div>
